// extracted by mini-css-extract-plugin
export default {"root":"NavBar_root__YtaCH","links":"NavBar_links__M84qm","link":"NavBar_link__y8qFH","current":"NavBar_current__m2l9u"};